// extracted by css-extract-rspack-plugin
export default {"confirmationWrapper":"Confirmation_confirmationWrapper__DMGyJ"};